<template>
    <div class="content_boss">

        <el-card class="box_card_l">
            <p class="box_card_l_p">当日预警处理数量</p>
            <el-card class="box_card_content" style="margin-bottom: 20px; background-color: rgba(234, 244, 255, 1);">
                <div class="content">
                    <div class="content_div_l">当日预警事件</div>
                    <div class="content_div_r">{{ earlyWarningData.total }}</div>
                </div>
            </el-card>

            <el-card class="box_card_content" style="background-color: rgba(235, 250, 242, 1); height: 150px;">
                <div class="content" style="margin-bottom: 20px; line-height: 50px;">
                    <div class="content_div_l">已处理数量</div>
                    <div class="content_div_r">{{ earlyWarningData.confirm_count }}</div>
                </div>

                <div class="content">
                    <div class="content_div_l">未处理数量</div>
                    <div class="content_div_r">{{ earlyWarningData.untreated_count }}</div>
                </div>
            </el-card>
        </el-card>

        <el-card class="box_card_r">
            <div class="box_card_r_box">
                <div class="box_card_r_student" style="margin-right: 20px;">
                    <p class="box_card_r_student_p">学生到校情况</p>
                    <el-card class="box_card_content_r" style="margin-bottom: 20px; background-color: rgba(234, 244, 255, 1);">
                        <div class="box_card_content_total">
                            <div class="box_card_content_total_l">全校学生人数</div>
                            <div class="box_card_content_total_r">{{ studentArrivalAtSchool.total }}</div>
                        </div>
                    </el-card>

                    <el-card class="box_card_content_r" style="background-color: rgba(235, 250, 242, 1); height: 150px;">
                        <div class="box_card_content_total" style="margin-bottom: 10px;">
                            <div class="box_card_content_total_l">实际到校学生人数</div>
                            <div class="box_card_content_total_r">{{ studentArrivalAtSchool.actual }}</div>
                        </div>
                        <div v-for="(item,index) in studentArrivalAtSchool.reason" :key="index" class="box_card_content_total">
                            <div class="reason_name">{{ item.reason_name }}</div>
                            <div class="count">{{ item.count }}</div>
                        </div>
                    </el-card>
                </div>

                <div class="box_card_r_student">
                    <p class="box_card_r_student_p">教师到校情况</p>
                    <el-card class="box_card_content_r" style="margin-bottom: 20px; background-color: rgba(234, 244, 255, 1);">
                        <div class="box_card_content_total">
                            <div class="box_card_content_total_l">教师数量</div>
                            <div class="box_card_content_total_r">{{ teachersArriveAtSchool.total }}</div>
                        </div>
                    </el-card>

                    <el-card class="box_card_content_r" style="background-color: rgba(235, 250, 242, 1); height: 150px;">
                        <div class="box_card_content_total" style="margin-bottom: 10px;">
                            <div class="box_card_content_total_l">实际到校人数</div>
                            <div class="box_card_content_total_r">{{ teachersArriveAtSchool.actual }}</div>
                        </div>
                        <div style="display: flex; flex-wrap: wrap; justify-content: space-between;" class="teachers_item">
                            <div v-for="(item,index) in teachersArriveAtSchool.reason" :key="index" style="display: flex; justify-content: space-between; width: 45%;">
                                <div style="color: #555555; font-size: 18px; font-weight: 600;">{{ item.reason_name }}</div>
                                <div style="color: #00bfbf; font-size: 20px; font-weight: 600;">{{ item.count }}</div>
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import { dataBoardWarn } from '@/api/index'
import { dataBoardAttendance } from '@/api/index'
import { unionHomeApi, uniResViewApi } from '@/api/index'

export default {
    props: {
        schoolId: {
            type: String,
        }
    },
    data() {
        return {
            earlyWarningData: {}, // 预警处理数量
            studentArrivalAtSchool: {}, // 学生到校情况
            teachersArriveAtSchool: {}, // 教师到校情况
        }
    },
    mounted() {
        this.change();
    },
    methods: {
        async change(e) {
            let data = {
                school_id: e,
            }
            const res = await this.axios.post(unionHomeApi, data);
            if (res.data.code == 1) {
                this.earlyWarningData = res.data.data.today;
                this.studentArrivalAtSchool = res.data.data.student;
                this.teachersArriveAtSchool = res.data.data.teacher;
            } else {
                this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error'
                });
            }
        },

    },
}
</script>


<style lang="scss" scoped>
.content_boss {
    width: 100%;
    height: 100%;
    display: flex;

    .box_card_l {
        width: 40%;
        border-radius: 10px;
        margin-right: 20px;
        .box_card_l_p {
            color: #81d3f8;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 10px;
        }
        .box_card_content {
            border-radius: 10px;
            .content {
                display: flex;
                justify-content: space-between;
                .content_div_l {
                    color: #555555;
                    font-size: 20px;
                    font-weight: 600;
                }
                .content_div_r {
                    color: #0b7efa;
                    font-size: 20px;
                    font-weight: 600;
                }
            }
        }
    }

    .box_card_r {
        width: 60%;
        border-radius: 10px;
        .box_card_r_box {
            display: flex;
            .box_card_r_student {
                width: 50%;
                .box_card_r_student_p {
                    color: #81d3f8;
                    font-size: 20px;
                    font-weight: 600;
                    margin-bottom: 10px;
                }
                .box_card_content_r {
                    border-radius: 10px;
                    .box_card_content_total {
                        display: flex;
                        justify-content: space-between;
                        .box_card_content_total_l {
                            color: #555555;
                            font-size: 20px;
                            font-weight: 600;
                        }
                        .box_card_content_total_r {
                            color: #0b7efa;
                            font-size: 20px;
                            font-weight: 600;
                        }
                        .reason_name {
                            color: #555555;
                            font-size: 18px;
                            font-weight: 600;
                        }
                        .count {
                            color: #00bfbf;
                            font-size: 20px;
                            font-weight: 600;
                        }
                    }
                    .teachers_item {
                        div:nth-child(even) {
                            padding-left: 10px;
                        }
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/homePage/educationHomePage/statistics.vue